<template>
  <div class="ticket-portal-header">
    <router-link :to="RouteAssistant.getTicketPortalListingRoute($route.params.accountId, $route.params.mailboxId)">
      <img v-if="hasLogoUrl" :src="logoUrl" class="logo">
      <span>{{ ticketPortalName }}</span>
    </router-link>
    <div class="meta">
      <span v-if="$screen.isTabletOrDesktop($mq)">
        <router-link :to="RouteAssistant.getTicketPortalProfileRoute()" >
          <i class="ddi ddi-edit" />
        </router-link>
      </span>
      <span><strong>{{ customer.name }}</strong></span>
      <span v-if="$screen.isTabletOrDesktop($mq)">{{customer.email}}</span>
      <router-link v-if="$screen.isMobile($mq) && !hideHomeOnMobile" :to="RouteAssistant.getTicketPortalListingRoute($route.params.accountId, $route.params.mailboxId)">
        <i class="ddi ddi-home" />
      </router-link>
      <dd-button
        size="tiny"
        type="flat"
        color="dark-teal"
        @click="signOut()"
      >Sign Out</dd-button>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'
import { ITicketPortalInputUpdateProfile } from '@/api/types/request.types'

export default defineComponent({
  name: 'TicketPortalHeader',

  components: {},
  props: {
    ticketPortalName: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: null,
    },
    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },
    hideHomeOnMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      showEditProfile: false,
      formData: {} as ITicketPortalInputUpdateProfile,
    }
  },

  computed: {
    hasLogoUrl(): boolean {
      return this.logoUrl !== null && this.logoUrl.length > 0
    },
  },

  methods: {
    async signOut() {
      try {
        const response = await TicketPortalAPI.get_LogoutWithRedirectLink(
          this.$route.params.mailboxId,
        )
        RouteAssistant.goToUrl(response.redirectLink)
      } catch (error) {
        this.$error.emit(error)
      }
    },
  },
})
</script>

<style lang="scss">
.ticket-portal-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-background-header);
  border-top: solid 1px $color--gray-45;
  border-bottom: solid 1px $color--gray-30;
  width: 100%;
  padding: 8px 16px;
  @include standard-box-shadow;

  .logo {
    height: 32px;
    padding-right: 10px;
  }

  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }

  > a {
    @include lettering--h4;
    margin: 0;
    color: var(--color-text-secondary);
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;

    &:hover {
      color: var(--color-text-secondary);
      background-color: var(--color-background-secondary);
      text-decoration: none;
    }
  }

  .meta {
    @include lettering--p-sm--no-color;
    color: var(--color-text-secondary);
    display: flex;
    align-items: center;
    gap: 10px;

    > span {
      padding-right: 10px;
      border-right: solid 1px $color--gray-75;
    }

    .ddi {
      cursor: pointer;
      color: var(--color-text-secondary);
    }

    @include media-breakpoint-down(sm) {
      border-top: solid 1px $color--gray-15;
      width: 100%;
      margin-top: 10px;
      padding-top: 10px;
      justify-content: flex-end;

      > span {
        padding: 0;
        border: none;

        &:first-child {
          margin-right: auto;
        }
      }
    }
  }
}
</style>
